<ng-content></ng-content>

<div class="menu-container dx-swatch-dark">
  <dx-tree-view 
    [items]="items"
    keyExpr="path"
    selectionMode="single"
    [selectByClick]=true
    [focusStateEnabled]="false"
    expandedExpr="isExpanded"
    expandEvent="click"
    (onItemClick)="onItemClick($event)"
    width="100%">
  </dx-tree-view>
</div>
